// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

// Global store
import store from './store/index';

// Vue resource library https://github.com/pagekit/vue-resource/blob/develop/docs/http.md
import resource from 'vue-resource';
Vue.use(resource);

// Validations library http://vee-validate.logaretm.com/
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {events: 'change'});

import vueConfig from 'vue-config';
Vue.use(vueConfig, wwfconfigs)
// Foundations
//require('foundation-sites');

// Vue Cookie
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

// Vue form wizard register
import VueFormWizard from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard);

// Components
import FormProduct from './components/product/FormProduct.vue';
import DollarHandleWidget from './components/product/DollarHandleWidget.vue';
import updateDetails from './components/donor/updateDetails.vue';
import DonateWidget from './components/product/DonateWidget.vue';
import myPetitionForm from './components/petitionForm.vue'

Vue.config.productionTip = false
import printJS from 'print-js'

import { getParameterByName, getNameByDonatiuonType, pushDatalayerPurchase, isEditMode, getNameByPaymentType } from './helpers'

import { mapState } from 'vuex'

var vm = new Vue({
  el: '#bodyapp',
  store: store,
  data() {
    return {
      thankYouPopup: {
        reveal: null,
        firstname: null,
        lastname: null,
        amount: null,
        certificatename: null,
        showCertificate: false,
        showWildcard: false,
        wildcardurl: null,
        certificateurl: null,
        isMonthly: false,
        isOpen: false
      },
      thankYouPopupPetition : {
        reveal: null, 
        title : '',
        message : '',
        shareButton : false,
        recommendedReading : false
      },
      isProcessing: false
    };
  },
  computed: mapState({
    donation: state => state.donation.donation,
    product: state => state.product.product,
    update_details: state => state.updates.update_details
  }),
  mounted() {
    // Don't mount the reveal if edit mode
    if (!isEditMode()) {
      console.log('no editmode');
      this.thankYouPopup.reveal = new Foundation.Reveal($('#reveal-dialog'));
      this.thankYouPopupPetition.reveal = new Foundation.Reveal($('#reveal-dialog-petition'));
    }
  },
  methods: {
    printCertificate: function () {
      printJS({ printable: 'certificate', type: 'html', targetStyles: ['*'] })
    },
    openThankYouPopup: function (e) {
      console.log('openThankYouPopup', e);
      [this.thankYouPopup.firstname, this.thankYouPopup.lastname, this.thankYouPopup.amount, this.thankYouPopup.showCertificate, this.thankYouPopup.certificateurl, this.thankYouPopup.isMonthly, this.thankYouPopup.showWildcard, this.thankYouPopup.wildcardurl] = e;
      if (this.thankYouPopup.reveal) {
        this.thankYouPopup.reveal.open();
        setTimeout(
          function () {
            this.thankYouPopup.isOpen = true;
          }.bind(this),
          200
        );

      }
    },
    openThankYouPopupPetition : function(e){        
      [this.thankYouPopupPetition.title, this.thankYouPopupPetition.message, this.thankYouPopupPetition.shareButton, this.thankYouPopupPetition.recommendedReading] = e;
      this.thankYouPopupPetition.reveal.open();
    },
    thankyou: function (amount, donationtype, transactionid, productname, postcode, firstname, lastname, producttype, certificateurl, productid, paymenttype, wildcardurl) {

      pushDatalayerPurchase(transactionid, productname, productid, producttype, getNameByDonatiuonType(donationtype), amount, postcode, getNameByPaymentType(paymenttype))

      this.openThankYouPopup([firstname, lastname, amount, producttype == 'adoption', certificateurl, donationtype == 'Regular',producttype == 'wildcard', wildcardurl]);

      console.log("thankyou");
      if (this.$refs.formproduct && paymenttype != "wwf_paypal") {
        this.$refs.formproduct.reset();
      }
    },
    confirmtransaction: function (transactionid) {
      this.thankyou(this.donation.amount, this.donation.type, transactionid, this.product.productname, this.donation.billing.postcode, this.donation.firstname, this.donation.lastname, this.product.producttype, this.product.certificateurl, this.product.id, this.donation.payementType, (this.donation.wildcard && this.donation.wildcard.pdf) ? this.donation.wildcard.pdf : null) 
    },
    confirmtransactionupdatedetail: function (maskedcard,name,date,type) {
      if (this.$refs.updatedetail) {
        this.$refs.updatedetail.confirmtransaction(maskedcard,name,date,type);
      }
    },
    retryupdatedetail: function retry() {
      if (this.$refs.updatedetail) {
        this.$refs.updatedetail.retry();
      }
    },
    retry: function () {
      if (this.$refs.formproduct) {
        this.$refs.formproduct.retry();
      }
    },
    disablesteps: function ()
    {
      if (this.$refs.formproduct) {
        this.$refs.formproduct.disablesteps();
      }
    }
  },
  components: {
    FormProduct,
    DollarHandleWidget,
    updateDetails,
    DonateWidget,
    myPetitionForm
  }
})

window.app = vm


// WEBPACK FOOTER //
// ./src/donate.main.js